import { create } from "zustand";
import { persist } from "zustand/middleware";
import { type User } from '@/entities/auth';
import { useImpersonationStore } from '@/features/user/model/impersonationStore';
import { useUserScopeStore } from '../model/user-scope.store';
import { useWorkRoleStore } from '@/features/user/model/workRoleStore';

interface AuthState {
  user: User | null;
  token: string | null;
  isAuthenticated: boolean;
  setUser: (user: User | null) => void;
  setToken: (token: string | null) => void;
  logout: () => void;
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      user: null,
      token: null,
      isAuthenticated: false,
      setUser: (user) =>
        set({
          user,
          isAuthenticated: !!user,
        }),
      setToken: (token) => set({ token }),
      logout: () => {
        useImpersonationStore.getState().stopImpersonation();
        useUserScopeStore.getState().clearScope();
        useWorkRoleStore.getState().setCurrentContext(null);
        set({
          user: null,
          token: null,
          isAuthenticated: false,
        });
      },
    }),
    {
      name: "auth-storage",
      partialize: (state) => ({
        user: state.user,
        token: state.token,
        isAuthenticated: state.isAuthenticated,
      }),
    }
  )
);